module.exports = __webpack_public_path__ + "img/smile.22927019.png";